import {MatchLiveData, MatchSimple} from '../../../utils/types';

const updateLiveMatches = (data: MatchSimple[], liveData: MatchLiveData): MatchSimple[] => data.map((match: MatchSimple) => {
  if (match._id === liveData._id) {
    return ({
      ...match,
      score: [liveData.scores.home, liveData.scores.away],
    });
  }
  return match;
});

export default updateLiveMatches;
